<template>
  <div>
    <div class="d-md-flex align-center">
      <h3 class="mb-0 mr-3">Payment Methods</h3>
      <v-btn
        :disabled="true"
        class="ml-3"
        @click="addMethod = !addMethod"
        color="primary">
        <v-icon class="mr-2">mdi-plus</v-icon>
        New method
      </v-btn>
    </div>

    <v-data-table
      :headers="table.headers"
      :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
      :items="methods.data"
      :server-items-length="methods.count"
      :disable-sort="true"
      :loading="table.loading"
      :footer-props="{itemsPerPageOptions: table.pageOptions}"
      :page="table.currentPage"
      :items-per-page="table.perPage"
      :single-expand="false"
      loading-text="Loading... Please wait"
      fixed-header
      :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
      item-class="td_title"
      color="#7F98A5"
      @pagination="updateTablePagination"
      @input="onSelect"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search"></DataTableTopBar>
      </template>
      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter type="items"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :type="item.value === 'amount'? 'range' : 'items'"
                     :min="item.value === 'amount' && table.filters[header.value].data[0] ? Number(table.filters[header.value].data[0].key): 0"
                     :max="item.value === 'amount' && table.filters[header.value].data[0] ? Number(table.filters[header.value].data[0].value): 0"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
                     @search="updateDataInFilters"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!-- header -->
      <!-- body -->
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="header.value === 'actions'">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="editHandler(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </template>
        <template v-if="header.value === 'tipalti'">
          <v-icon v-if = "item[header.value] == 1" >mdi-check-bold</v-icon>
        </template>
        <template v-if="header.value === 'blockedGoes'">
          <v-icon @click="openModal(item)">mdi-earth-off</v-icon>
        </template>
        <template v-else><short-text :text="item[header.value]"></short-text></template>
      </template>
      <!-- body -->
    </v-data-table>
    <DataTableBottomBar
            :showFilter="Object.values(table.filters).find(f => f.selected.length) !== undefined"
            @clearFilters="removeAllFilters"
            v-model="table.heightCounter"
    ></DataTableBottomBar>
    <NewMethod v-model="addMethod" @created="getTableData"></NewMethod>
    <PaymentGeoSettings
            ref="geoModal"
            :allCountries="allCountries"
            :bannedCountries="bannedCountries"
            :methodName="currentMethodName"
            @saved="handleSave"
    >
    </PaymentGeoSettings>
  </div>
</template>

<script>
  import DataTableTopBar from '@/components/common/DataTableTopBar';
  import DataTableBottomBar from '@/components/common/DataTableBottomBar';
  import store from '@/store';
  import {mapGetters} from "vuex";
  import paymentsApi from '@/api/payments';
  import NewMethod from "@/components/pages/methods/NewMethod";
  import PaymentGeoSettings from "@/components/pages/methods/PaymentGeoSettings";

  export default {
    props: {},
    data() {
      return {
        currentMethodName: '',
        currentMethodId: 0,
        allCountries: [],
        bannedCountries: [],
        addMethod: false,
        table: {
          heightCounter: 45,
          loading: false,
          searchInAffiliates: '',
          awaitingSearch: false,
          currentPage: 1,
          perPage: 25,
          pageChangedByMe: false,
          pageOptions: [10, 25, 50, 100],
          orderBy: '',
          sortColumnsAsc: true,
          headers: [
            { text: 'Name', value: 'name', align: 'center' }, //
            { text: 'Status', value: 'status', class: 'color', align: 'center' }, //
            { text: 'Minimum Amount', value: 'minimum_payment_amount', class: 'color', align: 'center' }, //
            { text: 'Blocked GEOs', value: 'blockedGoes', class: 'color', align: 'center' }, //
            { text: 'Tipalti', value: 'tipalti', class: 'color', align: 'center' }, //
            { text: 'Actions', value: 'actions', align: 'center', sortable: false}
          ],
          filters: {
            name: {selected: [], data: []},
            status: {selected: [], data: []},
            //minimum_amount: {selected: [], data: []},
            //tipalti: {selected: [], data: []},
          }
        },
        filtersMenu: false,
      }
    },

    async mounted() {
      this.byStatus = this.$route.path;
      await this.getTableData();
      this.getFiltersData();
      this.allCountries = await paymentsApi.getCountries();
    },

    methods: {
      editHandler(item) {
      store.dispatch('cards/ADD', {
        type: 'method',
        title: item.name,
        key: `method-${item.id}`,
        data: item
      })
    },
      getFiltersData() {
        const filters = {};
        const pathArray = this.$route.path.split('/');
        if (pathArray[2]) {
          filters.status = [pathArray[2].replaceAll('-', '_')];
        }
        for(const name in this.table.filters) {
          paymentsApi.getMethodFilter({
            filter: filters,
            name: name,
          }).then(res => {
            this.table.filters[name].data = res;
          });
        }
      },
      async getTableData() {
        this.table.loading = true;
        //this.activateFilters();
        const filters = await this.getFilters();
        console.log(filters);
      
        await store.dispatch('payments/getMethods', {
          orderBy: this.table.orderBy,
          orderDirectionAsc: this.table.sortColumnsAsc,
          page: this.table.currentPage,
          limit: this.table.perPage,
          filters: filters || null,
        });
        this.table.loading = false;
        console.log(this.methods);
      },
      /** todo add to helper */
      addParamsToLocation(params) {
        const query = JSON.stringify(params) === '{}' ? this.$route.path :
                this.$route.path + '?' + Object.keys(params).map(
                key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
                ).join('&')
        history.pushState({},null, query);
      },
      updateFiltersFromQuery() {
        const queryFilters = JSON.parse(this.$route.query.filters);
        for(const name in this.table.filters) {
          if(queryFilters[name]) {
            this.table.filters[name].selected = queryFilters[name];
          }
        }
      },
      async getFilters() {
        const filters = {};
        if (this.table.searchInAffiliates.length > 0) {
          filters['search'] = this.table.searchInAffiliates;
        }
        const pathArray = this.$route.path.split('/');
        if (pathArray[2]) {
          filters.status = [pathArray[2].replaceAll('-', '_')];
        }
        this.currentStatus = filters.status
        for(const name in this.table.filters) {
          if (this.table.filters[name].selected.length > 0) {
            filters[name] = this.table.filters[name].selected;
          }
        }
        return filters;
      },
      async submitFilter(data, entity) {
        this.table.currentPage = 1;
        this.table.pageChangedByMe = true;
        if(data && entity) {
          this.table.filters[entity].selected = data;
        }
        return await this.getTableData()
      },
      activateFilters() {
        const filtersForQuery = {};
        for (const name in this.table.filters) {
          if(this.table.filters[name].selected.length > 0) {
            filtersForQuery[name] = this.table.filters[name].selected;
          }
        }
        this.addParamsToLocation(
                JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
        );
      },
      async updateDataInFilters(data, modalName) {
        if(modalName) {
          const filters = {};
          const pathArray = this.$route.path.split('/');
          if (pathArray[2]) {
            filters.status = [pathArray[2].replaceAll('-', '_')];
          }
          paymentsApi.getFilter({
            filter: filters,
            name: modalName,
            searchFilter: data
          }).then(res => {
            this.table.filters[modalName].data = res;
          });
        }
      },
      async sortColumn(column) {
        this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
        this.table.orderBy = column
        await this.getTableData()
      },
      updateTablePagination(params){
        if (
                (this.table.currentPage === params.page &&
                        this.table.perPage === params.itemsPerPage) ||
                this.table.pageChangedByMe
        ) {
          this.table.pageChangedByMe = false;
          return
        }
        this.table.currentPage = params.page
        this.table.perPage = params.itemsPerPage
        if(this.$route.query.filters) {
          this.updateFiltersFromQuery();
        }
        this.getTableData();
      },
      search(value) {
        this.table.searchInAffiliates = value
        this.submitFilter();
      },
      async removeAllFilters() {
        for (let key in this.table.filters) {
          this.table.filters[key].selected = [];
        }
        await this.getTableData()
      },
      onSelect($event) {
        this.$emit('selected', $event)
      },
      async handleSave({ banned }) {
        console.log('Banned:', banned)
        console.log('ID: ', this.currentMethodId);
        await paymentsApi.updateMethodBannedGeos({id: this.currentMethodId, geos: JSON.stringify(banned)});
        await this.getTableData();
      },
      openModal(item) {
        this.$refs.geoModal.show(item.blockedGoes || []);
        const currentMethod = this.methods.data.find(m => m.id === item.id);

        this.currentMethodName = currentMethod.name;
        this.currentMethodId = currentMethod.id;

        try {
          this.bannedCountries = currentMethod.banned_geos
                  ? JSON.parse(currentMethod.banned_geos)
                  : [];

          return this.bannedCountries;
        } catch (e) {
          console.log(e);
          this.bannedCountries = [];
        }
      }
    },

    computed: {
      ...mapGetters('payments', ['payments','methods']),
    },

    components: {
      NewMethod,
      DataTableTopBar,
      DataTableBottomBar,
      PaymentGeoSettings,
    },
  }
</script>

<style lang="sass">
  .co-data-table
    .v-data-table__wrapper
      .v-data-table-header
        th
          white-space: nowrap
  .search_btn_wrap
    h1
      margin-bottom: 0
    .search_wrapper
      width: 250px
      padding-bottom: 15px

  .text-right
    text-align: right

</style>
